export default __webpack_public_path__ + "static/media/BotIcon.767c780d.jpg";